export interface SearchFilterOptions {
  // Items going to filter
  items: NodeListOf<Element>,

  // Used to get item text, default using item.textContent;
  getText?(item: HTMLElement): string
}

export default class SearchFilter {

  private options: SearchFilterOptions;

  constructor(options: SearchFilterOptions) {
    this.options = Object.assign({
      items: [],
      getText: function (item: HTMLElement): string {
        return item.textContent;
      },
    }, options);
  }

  public setItems(items) {
    this.options.items = items;
  }

  public filter(text: string) {
    var items = this.options.items;
    var getText = this.options.getText;

    var lookupValue = text.replace(/^\s+|\s+$/g, '');

    // if no search value, show all items
    if (lookupValue.length === 0) {
      [].forEach.call(items, function (item) {
        item.style.display = 'block';
      });
      return;
    }

    var lookupPattern = lookupValue
      .replace(/[<([{\\^\-=$!|\]})?*+.>]/g, (t) => {
        return '\\' + t;
      })
      .replace(/[aàáâãåäæ]/i, '[aàáâãåäæ]')
      .replace(/[eèéêë]/i, '[eèéêë]')
      .replace(/[iìíîï]/i, '[iìíîï]')
      .replace(/[oòóôõöø]/i, '[oòóôõöø]')
      .replace(/[uùúûü]/i, '[uùúûü]')
    ;

    var lookupRegex = new RegExp(lookupPattern, 'i' /* ignore case */);

    // search item by text
    [].forEach.call(items, function (item) {
      const itemText = getText(item);
      if (lookupRegex.test(itemText)) {
        item.style.display = 'block';
      } else {
        item.style.display = 'none';
      }
    });
  }
}
